import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import './index.css'

// Self-hosted fonts (Zupa for Logistics identity — no runtime Google Fonts, GDPR).
// Archivo: body + UI (400/500/600/700). Archivo Black: display headlines.
import '@fontsource/archivo/400.css'
import '@fontsource/archivo/500.css'
import '@fontsource/archivo/600.css'
import '@fontsource/archivo/700.css'
import '@fontsource/archivo-black/400.css'
// IBM Plex Mono: data / codes / micro-labels.
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource/ibm-plex-mono/600.css'
// Saira Stencil One: wordmark sub-mark, manifest section headers, stamps (scarcity).
import '@fontsource/saira-stencil-one/400.css'
import { applyTheme } from './stores/themeStore'

// Apply theme immediately on page load (before React renders)
const savedTheme = localStorage.getItem('zupa-theme');
if (savedTheme) {
  try {
    const parsed = JSON.parse(savedTheme);
    if (parsed.state?.theme) {
      applyTheme(parsed.state.theme);
    }
  } catch {
    // Ignore parse errors
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)
